interface Props {
  src: string;
  quality?: number;
  width?: number;
  [key: string]: string | number | undefined;
}

export default function imageLoader(params: Props) {
  const { src, quality, ...obj } = params;

  const urlSearchParams = new URLSearchParams();

  Object.keys(obj).map((key) => {
    if (params[key]) {
      urlSearchParams.append(key, String(params[key] ?? ""));
    }
  });

  return `${
    params.src
  }?fit=cover&${urlSearchParams.toString()}&format=webp&quality=${
    quality || 75
  }`;
}
